import { unloadOnOrphaned } from '@shared/extension/utils/events';
import { removeSentryLogsHandler } from './sentry-logs';
import { removeWindowLoadedHandler } from './window-loaded';
import { removeWindowMessagesHandler } from './window-messages';
import { removeSentryErrorsHandler } from './sentry-errors';
import { closeSentry } from '@shared/sentry';

export function startHandlingContentScriptsUnload(): void {
  unloadOnOrphaned('install-content-scripts', () => {
    removeWindowLoadedHandler();
    removeSentryLogsHandler();
    removeSentryErrorsHandler();
    removeWindowMessagesHandler();
    closeSentry();
  });
}
